

import axios from "axios";
import SystemConstant from "constants/SystemConstant";

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    if (error.response?.status === 401) {
      SystemConstant.cookies.remove("cartSession");
      SystemConstant.cookies.remove("userEmail");  
      SystemConstant.cookies.remove("firstname");  
      SystemConstant.cookies.remove("userCartToken");  

      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;